/** Akıl listelerinde birincil satır: müvekkil ad soyad + TC */

function withTc(name, tc) {
    const n = (name || "").trim();
    const t = (tc || "").trim();
    if (!n && !t) return "";
    if (t && n && !n.includes(`(${t})`)) return `${n} (${t})`;
    return n || (t ? `TC ${t}` : "");
}

export function akilItemPrimary(it) {
    if (!it) return "";
    const tc = it.tc || it.tc_kimlik_no || it.muvekkil_tc;
    const name =
        it.ad_soyad ||
        it.muvekkil_ad_soyad ||
        (it.muvekkil && !String(it.muvekkil).startsWith("MBS-") ? it.muvekkil : "") ||
        (it.label && !String(it.label).startsWith("MBS-") ? it.label : "");
    const merged = withTc(name, tc);
    if (merged) return merged;
    if (it.label) return it.label;
    return it.id != null ? `#${it.id}` : "Kayıt";
}

export function akilItemSecondary(it) {
    if (!it) return "";
    return (
        it.sub ||
        it.status ||
        (it.gecen_sure != null ? `${it.gecen_sure} gün` : "") ||
        it.tarih ||
        it.durum ||
        it.dosya_no ||
        ""
    );
}
